import {
  SET_BLOGS,
  SET_RB_BLOGS,
  FETCH_BLOG_LOADING,
  SET_BLOG_FILTER,
  SET_GALLERY_MEDIA,
  SET_GALLERY_TOTAL_PAGES,
  NEW_BLOG,
  BLOG_TOTAL_PAGES,
  LOADING_GET_BLOG_ITEMS,
  CLEAR_RB_BLOGS,
} from "../../constants/ActionTypes";

export const setBlog = (blog) => {
  return (dispatch) => {
    dispatch({
      type: SET_BLOGS,
      payload: blog,
    });
  };
};

export const setRBBlog = (blog) => {
  return (dispatch) => {
    dispatch({
      type: SET_RB_BLOGS,
      payload: blog,
    });
  };
};

export const clearRbBlogs = () => {
  return (dispatch) => {
    dispatch({
      type: CLEAR_RB_BLOGS,
    });
  };
};

export const setFetchLoading = (loading) => {
  return (dispatch) => {
    dispatch({
      type: FETCH_BLOG_LOADING,
      payload: loading,
    });
  };
};

export const setBlogFilter = (filter) => {
  return (dispatch) => {
    dispatch({
      type: SET_BLOG_FILTER,
      payload: filter,
    });
  };
};
export const setGallerydata = (data) => {
  return (dispatch) => {
    dispatch({
      type: SET_GALLERY_MEDIA,
      payload: data,
    });
  };
};

export const setGalleryTotalPage = (totalPages) => {
  return (dispatch) => {
    dispatch({
      type: SET_GALLERY_TOTAL_PAGES,
      payload: totalPages,
    });
  };
};

export const setBlogTotalPages = (totalPages) => {
  return (dispatch) => {
    dispatch({
      type: BLOG_TOTAL_PAGES,
      payload: totalPages,
    });
  };
};

export const setNewBlog = (newBlog) => {
  return (dispatch) => {
    dispatch({
      type: NEW_BLOG,
      payload: newBlog,
    });
  };
};

export const setBlogLoadingGetData = (loading) => {
  return (dispatch) => {
    dispatch({
      type: LOADING_GET_BLOG_ITEMS,
      payload: loading,
    });
  };
};
